import { API_URL_POST_SEND_COMMUNICATION } from "@/constants/api.constants";
import { pslClient } from "@/common/http-common";

export const communication = {
  namespaced: true,
  state: {},
  actions: {
    send({ rootGetters }, data) {
      const communicateRequest = {
        Type: data.type,
        QuoteReference: data.quoteReference,
        SelectedQuote: data.selectedQuote,
      };
      const config = rootGetters["questions/httpConfig"];
      return pslClient
        .post(API_URL_POST_SEND_COMMUNICATION, communicateRequest, config)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
  getters: {},
  mutations: {},
};
